import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { adminnavigationLinks } from "../data/navData";
import DashboardLayout from "../layout/DashboardLayout/DashboardLayout";
import AdminHome from "../pages/adminPages/AdminHome";
import AdminAcademies from "../pages/adminPages/AdminAcademies";
import AdminUser from "../pages/adminPages/AdminUser";
import AdminAssets from "../pages/adminPages/AdminAssets";
import AdminAssetCategoryPage from "../pages/adminPages/AdminAssetCategoryPage";
import AdminDynamicAssetCategory from "../pages/adminPages/AdminDynamicAssetCategory";
import AssetApproval from "../pages/adminPages/AssetApproval";
import AdminRepair from "../pages/adminPages/AdminRepair";
import AdminMaintenance from "../pages/adminPages/AdminMaintenance";
import AdminRReport from "../pages/adminPages/AdminRReport";
import AdminMReport from "../pages/adminPages/AdminMReport";
import Account from "../components/Account/Account";
import FeedbackReport from "../pages/FeedbackReport";
// import FeedbackReport from "../pages/cfmPages/CfmFeedback";
import ProtectedRoute from "./ProtectedRoute";
import Vendors from "../pages/adminPages/Vendors";
import AdminAttendance from "../pages/adminPages/AdminAttendance";
import AdminAttendanceRecords from "../pages/adminPages/AdminAttendanceRecords";
import AdminEmployeeLeaveRequests from "../pages/adminPages/AdminEmployeeLeaveRequests";
import AdminEmployeeAttendance from "../pages/adminPages/AdminEmployeeAttendance";
import CreateCalendar from "../pages/adminPages/CreateCalendar";
import AttendanceRecordDetail from "../pages/attendance/AttendanceRecordDetail";
import Calendar from "../components/Calendar/Calendar";
import UserDetails from "../pages/UserDetails";

const AdminRoutes = () => {
  return (
    <DashboardLayout
      navigationLinks={adminnavigationLinks}
      roleBasePath="admin"
      useApiLogout={true}
    >
      <Routes>
        {/* Admin Routes - Relative paths under /admin/* */}
        <Route
          path=""
          element={
            <ProtectedRoute element={<AdminHome />} requiredRole="admin" />
          }
        />
        <Route
          path="attendance/record/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="academies"
          element={
            <ProtectedRoute element={<AdminAcademies />} requiredRole="Admin" />
          }
        />
        <Route
          path="users"
          element={
            <ProtectedRoute element={<AdminUser />} requiredRole="Admin" />
          }
        />
        <Route
          path="users/:email"
          element={
            <ProtectedRoute element={<UserDetails />} requiredRole="Admin" />
          }
        />
        <Route
          path="assets"
          element={
            <ProtectedRoute element={<AdminAssets />} requiredRole="Admin" />
          }
        />
        <Route
          path="assets/building"
          element={
            <ProtectedRoute
              element={<AdminAssetCategoryPage category="Building" title="Building" />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="assets/landscaping"
          element={
            <ProtectedRoute
              element={<AdminAssetCategoryPage category="Landscaping" title="Landscaping" />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="assets/machinery"
          element={
            <ProtectedRoute
              element={<AdminAssetCategoryPage category="Machinery" title="Machinery" />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="assets/room"
          element={
            <ProtectedRoute
              element={<AdminAssetCategoryPage category="Room" title="Room QR" />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="assets/:categoryName"
          element={
            <ProtectedRoute
              element={<AdminDynamicAssetCategory />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="approval"
          element={
            <ProtectedRoute element={<AssetApproval />} requiredRole="Admin" />
          }
        />
        <Route
          path="repair-maintenance"
          element={
            <ProtectedRoute element={<AdminRepair />} requiredRole="Admin" />
          }
        />
        <Route
          path="preventive-maintenance"
          element={
            <ProtectedRoute
              element={<AdminMaintenance />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="repair-report"
          element={
            <ProtectedRoute element={<AdminRReport />} requiredRole="Admin" />
          }
        />
        <Route
          path="maintenance-report"
          element={
            <ProtectedRoute element={<AdminMReport />} requiredRole="Admin" />
          }
        />
        <Route
          path="account"
          element={
            <ProtectedRoute element={<Account />} requiredRole="Admin" />
          }
        />
        <Route
          path="feedback"
          element={
            <ProtectedRoute element={<FeedbackReport />} requiredRole="Admin" />
          }
        />
        <Route
          path="vendor"
          element={
            <ProtectedRoute element={<Vendors />} requiredRole="Admin" />
          }
        />
        <Route
          path="attendance"
          element={
            <ProtectedRoute
              element={<AdminAttendance />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="attendance/record"
          element={
            <ProtectedRoute
              element={<AdminAttendanceRecords />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="attendance/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="attendance/employee-leave-requests"
          element={
            <ProtectedRoute
              element={<AdminEmployeeLeaveRequests />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="attendance/employee-attendance"
          element={
            <ProtectedRoute
              element={<AdminEmployeeAttendance />}
              requiredRole="Admin"
            />
          }
        />
        <Route
          path="calendar/create"
          element={
            <ProtectedRoute element={<CreateCalendar />} requiredRole="Admin" />
          }
        />
        <Route
          path="calendar/:year"
          element={
            <ProtectedRoute element={<Calendar />} requiredRole="Admin" />
          }
        />

        {/* 404 Page */}
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      </Routes>
    </DashboardLayout>
  );
};

export default AdminRoutes;
